import type { AppLocale } from "./config";
import { LOCALE_COOKIE } from "./config";

const ONE_YEAR = 60 * 60 * 24 * 365;

export function localeCookieHeaderValue(locale: AppLocale): string {
  return `${LOCALE_COOKIE}=${locale}; Path=/; Max-Age=${ONE_YEAR}; SameSite=Lax`;
}

/** Client-side */
export function writeLocaleCookie(locale: AppLocale): void {
  if (typeof document === "undefined") return;
  document.cookie = localeCookieHeaderValue(locale);
}

export function readLocaleCookie(): string | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${LOCALE_COOKIE}=([^;]*)`));
  return m?.[1] ? decodeURIComponent(m[1]) : null;
}
